<template>
  <modal :show="visible" @close="visible = false" modalClasses="modal-xxl">
    <div slot="header">
      <h3>Thông số kỹ thuật của quy cách</h3>
    </div>
    <block ref="bmdal">
      <h4>Thông số - Số lượng mẫu : {{ Specify.quantity_default }} M</h4>
      <soft-table
        @rowSelected="tbSetRowSelected"
        @rowClicked="tbRowClicked"
        class="table align-items-center table-flush"
        tbody-classes="list"
        :pending="false"
        :dataTable="SpecifyFeatures"
        :fields="fields"
        :showAll="true"
        :norecordAdd="handleAddNew"
        :minHeight="$hMainContent - 280 > 250 ? $hMainContent - 280 : 250"
        :contextMenus="[
          {
            key: 'new',
            icon: 'fa-plus',
            label: 'Thêm mới'
          },
          {
            key: 'copy',
            icon: 'fa-copy',
            label: 'Copy dòng này'
          },
          {
            key: 'edit',
            icon: 'fa-edit',
            label: 'Sửa dòng này'
          },
          {
            key: 'delete',
            icon: 'fa-trash',
            label: 'Xóa dòng này'
          }

        ]"
        @contextMenuItemClick="tbHandleContextMenuItemClick"
        ref="soft-table"
      >
      </soft-table>
      <control-mini
        :countChecked="countChecked"
        @doAddNew="handleAddNew"
        @doEdit="handleEdit"
        @search="handleSearch"
        @doDelete="handleDeletes"
      ></control-mini>
      <hr />
      <div class="d-flex">
        <h4>Ghi chú :</h4>
        <b-button
          @click="specParameterAddRow()"
          variant="success px-1 py-0 ml-2 mb-2"
        >
          <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
        </b-button>
      </div>
      <div class="table-reponsive table-striped table-bordered">
        <table class="table">
          <template v-for="(item, index) in productParameters">
            <tr v-if="!item.edit" :key="index">
              <!-- <td class="bg-info text-light col-fix ">{{ index + 1 }}</td> -->
              <td><div v-html="item.col1"></div></td>
              <!-- <td>{{ item.col2 }}</td>
              <td>{{ item.col3 }}</td>
              <td>{{ item.col4 }}</td> -->
              <td class="col-fix text-center">
                <b-button
                  @click="specParameterDelete(index, item)"
                  variant="outline-danger px-1 py-0"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </b-button>
                <b-button
                  @click="specParameterEditRow(item)"
                  variant="outline-primary px-1 py-0"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </b-button>
              </td>
            </tr>
            <tr v-else :key="'x'+index">
              <!-- <td class="bg-info text-light col-fix ">{{ index + 1 }}</td> -->
              <td class="p-1">
                <!-- <base-input class="mb-0" v-model="item.col1"> </base-input> -->
                <ckeditor
                  :editor="editor"
                  v-model="item.col1"
                  @ready="onReady"
                  :config="editorConfig"
                ></ckeditor>
              </td>
              <!-- <td class="p-1">
                <base-input class="mb-0" v-model="item.col2"> </base-input>
              </td>
              <td class="p-1">
                <base-input class="mb-0" v-model="item.col3"> </base-input>
              </td>
              <td class="p-1">
                <base-input class="mb-0" v-model="item.col4"> </base-input>
              </td> -->
              <td class="col-fix text-center">
                <b-button
                  @click="specParameterSaveRow(item)"
                  variant="outline-success px-1 py-0"
                >
                  <i class="fa fa-save" aria-hidden="true"></i>
                </b-button>
                <b-button
                  v-if="item.id"
                  @click="specParameterCancelEdit(item)"
                  variant="outline-danger px-1 py-0"
                >
                  <i class="fa fa-window-close" aria-hidden="true"></i>
                </b-button>
                <b-button
                  v-else
                  @click="specParameterDelete(index, item)"
                  variant="outline-danger px-1 py-0"
                >
                  <i class="fa fa-backspace" aria-hidden="true"></i>
                </b-button>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </block>
    <spec-feature-form-modal
      ref="specFeatureFormModal"
    ></spec-feature-form-modal>
    <hr />
    <div>
      <button type="button" @click="handleClose" class="btn btn-secondary">
        Đóng
      </button>
    </div>
  </modal>
</template>

<script>
import { productService } from "@/_services";
import specFeatureFormModal from "./_SpecFeatueFormModal";

import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  components: {
    specFeatureFormModal,
    ckeditor: CKEditor.component
  },
  data() {
    return {
      visible: false,
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "checkbox"
        },
        {
          variant: "info",
          stickyColumn: true,
          key: "deportment",
          label: "Công dụng",
          sortable: true
        },
        {
          key: "material",
          label: "Nguyên liệu",
          sortable: true
        },
        {
          key: "spec",
          label: "Quy cách",
          sortable: true
        },
        {
          key: "color",
          label: "Màu sắc",
          sortable: true
        },
        {
          key: "colorCode1",
          label: "Mã màu 1",
          sortable: true
        },
        {
          key: "colorCode2",
          label: "Mã màu 2",
          sortable: true
        },
        {
          key: "quantity",
          label: "Số lượng",
          sortable: true
        },
        {
          key: "percentYarn",
          label: "% Sợi",
          sortable: true
        },
        {
          key: "weight",
          label: "Trọng Lượng",
          sortable: true
        },
        {
          key: "percentLoss",
          label: "% Hao hụt",
          sortable: true
        },
        {
          key: "total_weight",
          label: "Tổng trọng lượng",
          sortable: true
        }
      ],
      SpecifyFeatures: [],
      SpecifyFeaturesSelecteds: [],
      productParameters: [],
      Specify: {},
      SpecifyServer: {}, //quy cách được load lại từ server
      countChecked: 0,
      product: {},
      info: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bold",
          "italic",
          "link",
          "underline",
          "strikethrough",
          "|",
          "alignment",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "|",
          "indent",
          "outdent",
          "link",
          "insertTable",
          "tableColumn",
          "tableRow",
          "mergeTableCells"
        ]
      }
    };
  },
  methods: {
    featchData() {
      productService
        .findSpec(this.Specify.id)
        .then(res => {
          this.SpecifyServer = res.data;
          this.SpecifyFeatures = res.data.productFeatures;
          res.data.productParameters.forEach(element => {
            element.edit = false;
          });
          this.productParameters = res.data.productParameters;
        })
        .finally(() => {});
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    setData(product, Specify) {
      this.product = product;
      this.Specify = Specify;
      if (Specify) {
        this.featchData();
      }
    },
    doSave() {},
    handleClose() {
      this.visible = false;
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      if (keyword == "") {
        this.SpecifyFeatures = this.SpecifyServer.productFeatures;
      } else {
        this.SpecifyFeatures = this.SpecifyServer.productFeatures.filter(
          item => {
            //let keys = Object.keys(item)
            let keysCheck = [
              "deportment",
              "material",
              "spec",
              "color",
              "colorCode1",
              "colorCode2"
            ];
            for (let i = 0; i < keysCheck.length; i++) {
              const key = keysCheck[i];
              let value = item[key];
              if (
                value &&
                value
                  .toString()
                  .toLowerCase()
                  .includes(keyword.toLowerCase())
              ) {
                return true;
              }
            }
            return false;
          }
        );
      }
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == "copy") {
        let newItem = Object.assign({}, a.data);
        delete newItem.id;
        this.$refs.specFeatureFormModal.visible = true;
        this.$refs.specFeatureFormModal.setData(this.SpecifyServer, newItem);
      } else if (a.menu.key == "edit") {
        this.$refs.specFeatureFormModal.visible = true;
        this.$refs.specFeatureFormModal.setData(this.SpecifyServer, a.data);
      } else if (a.menu.key == "new") {
        this.handleAddNew();
      } else if (a.menu.key == "delete") {
        var self = this;
        this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.doDeleteSpecifyFeatures([a.data.id]);
          }
        });
      }
    },
    handleEdit() {
      this.$refs.specFeatureFormModal.visible = true;
      this.$refs.specFeatureFormModal.setData(this.SpecifyServer, this.info);
    },
    handleAddNew() {
      this.$refs.specFeatureFormModal.visible = true;
      this.$refs.specFeatureFormModal.setData(this.SpecifyServer, false);
    },
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    handleDeletes() {
      if (this.countChecked == 0) return;
      let list = [];
      this.SpecifyFeaturesSelecteds.forEach(element => {
        list.push(element.id);
      });
      this.doDeleteSpecifyFeatures(list);
    },
    doDeleteSpecifyFeatures (list) {
      //alert(list);\
      var self = this;
      productService.specFeatureRemoveList({ list: list }).finally(() => {
        // this.$emit("changeData");
        self.featchData();
      });
    },
    tbSetRowSelected(items) {
      this.SpecifyFeaturesSelecteds = items;
      this.countChecked = items.length;
    },
    specParameterDelete(index, item) {
      if (item.edit) {
        this.productParameters.splice(index, 1);
      } else {
        var self = this;
        this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            productService.specFeatureRemoveParameter(item.id).then(res => {
              self.$alertify.success(res.message, {
                duration: 4000
              });
              self.productParameters.splice(index, 1);
            });
          }
        });
      }
    },
    specParameterAddRow() {
      this.productParameters.push({
        edit: true,
        col1: "Chỉ đen",
        col2: "",
        col3: "",
        col4: ""
      });
    },
    specParameterCancelEdit(item) {
      item.edit = false;
      item.col1 = item.tmp.col1;
      item.col2 = item.tmp.col2;
      item.col3 = item.tmp.col3;
      item.col4 = item.tmp.col4;
      delete item.tmp;
      this.productParameters.splice(0, 0);
    },
    specParameterEditRow (item) {
      let tmp = Object.assign({}, item);
      item.tmp = tmp;
      item.edit = true;
      this.productParameters.splice(0, 0);
    },
    specParameterSaveRow(item) {
      delete item.tmp;
      productService
        .specFeatureSaveParameter(item, this.Specify.id)
        .then(res => {
          item.edit = false;
          item.id = res.data.id;
          item.dateCreated = res.data.dateCreated;
          item.dateUpdated = res.data.dateUpdated;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        });
    }
  }
};
</script>
